var site = site || {};
site.Utilities = (function () {
    // Functions

    // var functionName = function() {
    //
    // };

    /**
     * @typedef {Object} ShowCenteredPopupMessageRequest
     * @property {"alert-warning"|"alert-danger"|"alert-primary"|"alert-custom-warning"|string} alertClass
     * @property {"text-light"|"text-dark"} alertTextClass
     * @property {string} message
     * @property {string} iconClass
     * @property {number} timeout
     */

    /**
     * @typedef {Object} ShowCenteredPopupMessageResponse
     * @property {Promise} popupDismissed A promise that resolves when the
     * popup is dismissed (either by timeout or by the user).
     * @property {() => {}} dismiss
     */

    /**
     * Responsible for displaying a fixed and centered popover message.
     * @param {ShowCenteredPopupMessageRequest} request
     * @returns {ShowCenteredPopupMessageResponse}
     */
    var showCenteredPopupMessage = function (request) {
        var alertHtml = `<div class="sp-centered-popup-message position-fixed alert shadow ${request.alertClass} ${request.alertTextClass} z-popover"><div class="d-flex flex-nowrap align-items-start justify-content-start"><div class="flex-fill text-center"><i class="mr-1 fa ${request.iconClass}"></i><span>${request.message}</span></div><i class="dismiss-alert fas fa-times float-right"></i></div></div>`;
        var $alert = $(alertHtml);
        var timeout = null;
        $alert.appendTo($("body"));

        var dismissedPromise = null;
        var dismissedPromiseResolveFn = null;

        dismissedPromise = new Promise(function (resolve, reject) {
            dismissedPromiseResolveFn = resolve;
        });

        var dismiss = function() {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }

            // Fade out the alert before removing it.
            $alert.fadeOut(200, function () {
                $alert.remove();
                dismissedPromiseResolveFn();
            });
        }

        $alert.one("click", ".dismiss-alert", function (evt) {
            dismiss();
        });

        if ((request.timeout ?? 0) > 0) {
            timeout = setTimeout(dismiss, request.timeout);
        }

        return {
            dismiss: dismiss,
            popupDismissed: dismissedPromise,
        };
    }

    var backgroundImageElement = function() {
        $('.js-bg-image').css('background-image', function () {
            var bgUrlEncode = encodeURI($(this).data("bg-img"));
            var bg = 'url("' + bgUrlEncode  + '")';
            return bg;
        });
    }

    var partImageToggle = function() {
        $('.js-part-image').attr('src', $('.js-part:checked').data('img'));
        
        $('.js-part').on('change', function(){
            if(this.checked){
                $('.js-part-image').attr('src', $(this).data('img'));
            }
        })
    }
    function getUrlParams() {
        var params = window.location.search.split('?')[1];
        if (params) {
            var obj = params.split("&").reduce(function (prev, curr, i, arr) {
                var p = curr.split("=");
                prev[decodeURIComponent(p[0])] = decodeURIComponent(p[1]);
                return prev;
            }, {});
            return obj;
        }
        return {};
    };
    function setProductLinks() {
        $('a[data-product-slug]').each(function () {
            $(this).attr('href', '/products/' + $(this).data('product-slug').toLowerCase());
        })
    }
    function stopVideoOnModalClose() {
        $(".js-close").click(function () {
            var thisModalVideo = $(this).next('.notch-md').find('iframe');
            var videoSrc = thisModalVideo.attr('src');
            thisModalVideo.attr("src", videoSrc);
        });
    }



    // Return
    return {
        // functionName : functionName
        backgroundImageElement : backgroundImageElement,
        partImageToggle: partImageToggle,
        getUrlParams: getUrlParams,
        setProductLinks: setProductLinks,
        stopVideoOnModalClose: stopVideoOnModalClose,
        showCenteredPopupMessage: showCenteredPopupMessage,
    };
}());